import { useEffect, useState } from "react";
import {ContactMeContainer, Close, CloseIcon, ContactMeContent, ContactMeHeadline, ContactMeSubtitle, ModalInputContainer, ModalInput, ErrorMessage, Button, HighlightedBox, HighlightedBoxContainer, HighlightedBoxLabel, HighlightedBoxNumb, HighlightedBoxLeft, HightlightedBoxRight, HighlightedBoxHeadline, Hr, ValueDef, ConsentCheckbox, ConsentLabel, ConsentRow, Success, SuccessContainer } from "./Leadpopup.style";
import { postSalaryInsuranceLeadData } from "../../../../../utils/api";
import { SalaryInsuranceLeadModel } from "../../../../../types/SalaryInsuranceLeadModel";
import { getCookie } from "../../../../../utils/cookieService";
import Analytics from "../../../../../utils/analytics";

interface Props {
      onClose: () => void;
      onSuccess?: () => void;
      salary: string;
      period: string;
      amount: string;
      fullAmount: string;
      price: string;
      leverandoer: string;
      headline: string | undefined;
      subtitle: string | undefined;
      wantsSalaryInsurance: boolean;
}

export default function Leadpopup({onClose, onSuccess, salary, period, amount, fullAmount, price, leverandoer, headline, subtitle, wantsSalaryInsurance }:Props) {
    const [firstName, setFirstName] = useState<string>("");
    const [mobile, setMobile] = useState<string>("");
    const [showMobileError, setShowMobileError] = useState<boolean>(false);
    const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
    const [successfullySent, setSuccessfullySent] = useState<boolean>(false);

    //Prevent the page behind the overlay from scrolling at the same time
    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, []);

    const getNameIsValid = (value: string) => value.trim().length >= 2;

    const getMobileIsValid = (value: string) => {
        const normalizedMobile = value.replace(/\s|-/g, "");
        return /^(?:\+45)?\d{8}$/.test(normalizedMobile);
    };

    //Api send contact me
    const onSend = async () => {
        const cookie = getCookie("__exponea_etc__");

        let lead = {} as SalaryInsuranceLeadModel;
        lead.name = firstName.trim()
        lead.phone = mobile.trim()
        lead.grosspay = `${salary}`
        lead.dinpris  = `${price}`
        lead.payout = `${fullAmount}`
        lead.payoutduration = `${period}`
        lead.product = `Lønsikring`
        lead.cookie = `${cookie}`
        lead.email = ""
        lead.leverandoer = `${leverandoer}` || "www.ase.dk"

        try {
            await postSalaryInsuranceLeadData({ ...lead });
            // Call callbacks after successful submission
            setSuccessfullySent(true);
            onSuccess?.();
            Analytics.getInstance().trackSalaryInsuranceAction("form_completed", salary, amount, period, price, fullAmount, "salaryinsurance_config");
            // Close popup after a brief delay to ensure state updates
           /*  setTimeout(() => {
                onClose();
            }, 100); */
        } catch (error) {
            console.error("Error submitting lead:", error);
            // Still close popup and show confirmation even if there's an error
            onSuccess?.();
            setTimeout(() => {
                onClose();
            }, 100);
        }
    } 

    const onClosePopup = () => {
        onClose()
        Analytics.getInstance().trackSalaryInsuranceAction("form_closed", salary, amount, period, price, fullAmount, "salaryinsurance_config")
    }

    //Validation for contact me inputs
    const checkSubmit = () => {
        const isNameValid = getNameIsValid(firstName);
        const isMobileValid = getMobileIsValid(mobile);

        setShowFirstNameError(!isNameValid);
        setShowMobileError(!isMobileValid);

        if (isNameValid && isMobileValid) {
            onSend()
            setFirstName("")
            setMobile("")
            setShowMobileError(false)
            setShowFirstNameError(false)
        }
    }

    const isFormValid = getNameIsValid(firstName) && getMobileIsValid(mobile);

    return (
        <ContactMeContainer data-attribute="contact-me">
            <ContactMeContent>
                <Close>
                    <CloseIcon onClick={onClosePopup}/>
                </Close>
                {successfullySent && 
                <SuccessContainer>
                    <Success />
                </SuccessContainer>
                }
                <ContactMeHeadline>{headline}</ContactMeHeadline>
                <ContactMeSubtitle>{subtitle}</ContactMeSubtitle>
                {wantsSalaryInsurance && (
                <HighlightedBox>
                    <HighlightedBoxHeadline>Dine valg</HighlightedBoxHeadline>
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Dækningsperiode</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{period} <ValueDef>mdr.</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                    <Hr />
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Bruttoløn</HighlightedBoxLabel>
                            <HighlightedBoxLabel>Dækningssum</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{salary} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                            <HighlightedBoxNumb>{amount} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                    <Hr />
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Samlede udbetaling</HighlightedBoxLabel>
                            <HighlightedBoxLabel>Din pris</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{fullAmount} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                            <HighlightedBoxNumb>{price} <ValueDef> kr./md</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                </HighlightedBox>
                )}
                {!successfullySent && (
                <>
                <ModalInputContainer>
                    <ModalInput id="name" type="text" placeholder="Dit navn" autoComplete="given-name"  
                        value={firstName}
                        onChange={(e) => {
                            setFirstName(e.currentTarget.value);
                            if (showFirstNameError) {
                                setShowFirstNameError(!getNameIsValid(e.currentTarget.value));
                            }
                        }}
                    />
                    {showFirstNameError &&
                        <ErrorMessage>Hov, indtast dit navn (mindst 2 tegn)</ErrorMessage>
                    }
                    <ModalInput id="tel" type="tel" placeholder="Dit telefonnummer" autoComplete="tel"
                        value={mobile}
                        onChange={(e) => {
                            setMobile(e.currentTarget.value);
                            if (showMobileError) {
                                setShowMobileError(!getMobileIsValid(e.currentTarget.value));
                            }
                        }}
                    />
                    {showMobileError && 
                        <ErrorMessage>Hov, indtast et gyldigt telefonnummer (8 cifre)</ErrorMessage>
                    }
                </ModalInputContainer>
                <Button
                    className="button"
                    as="button"
                    type="button"
                    onClick={checkSubmit}
                    active={isFormValid}
                    disabled={!isFormValid}
                >
                    Ring mig op
                </Button>
                </>
                )}
            </ContactMeContent>
        </ContactMeContainer>
    )
}